"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ravenJs = _interopRequireDefault(require("raven-js"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 捕获卡顿
// 获取fps、间隔抽样
// 获取fps的目的是为了判断是否卡顿
var ONE_SECOND = 1000;

var rAF = function () {
  var SIXTY_TIMES = 60;
  var requestAnimationFrame = window.requestAnimationFrame;

  if (requestAnimationFrame) {
    return function (cb) {
      var timer = requestAnimationFrame(function () {
        cb();
        window.cancelAnimationFrame(timer);
      });
    };
  }

  return function (cb) {
    var timer = setTimeout(function () {
      cb();
      clearTimeout(timer);
    }, ONE_SECOND / SIXTY_TIMES);
  };
}();

var _default = function _default() {
  var stucks = [];
  var startTime = Date.now();

  var loop = function loop() {
    var startCountTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
    var lastFrameCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var now = Date.now();
    var nowFrameCount = lastFrameCount + 1;

    if (now > ONE_SECOND + startCountTime) {
      var timeInterval = (now - startCountTime) / ONE_SECOND;
      var fps = Math.round(nowFrameCount / timeInterval);

      if (fps > _constants.FPS_STUCK_VALUE) {
        stucks.pop();
      } else {
        stucks.push(fps);
      } // 连续三次小于20 上报卡顿


      if (stucks.length === _constants.STUCK_TIMES_MAX) {
        _ravenJs.default.captureException(new Error("Page Stuck captured: ".concat(location.href, " ").concat(stucks.join(','), " ").concat(now - startTime, "ms"))); // 清空卡顿


        stucks.length = 0;
      } // 等待时间重新统计


      var timer = setTimeout(function () {
        loop();
        clearTimeout(timer);
      }, _constants.FPS_SAMPLE_TIME);
      return;
    }

    rAF(function () {
      return loop(startCountTime, nowFrameCount);
    });
  };

  loop();
};

exports.default = _default;